// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"styles_modalTitle__6fga4"};